"use client";

/**
 * P2-01 · Cart-count seam. The header renders a live badge from this hook.
 * P4-01 wired it to the real cart store: it reads the server-authoritative unit
 * count from the cart context, falling back to 0 when rendered outside the
 * provider (so it can never throw in the header).
 */
import { useCartContext } from "~/lib/cart/use-cart";

export function useCartCount(): number {
  return useCartContext()?.count ?? 0;
}
